import { BillingBannerEvents } from "@redotech/redo-merchant-general-app/billing/billing-events";

export const PlatformEvents = {
  // Home page
  HOMEPAGE_VIEWED: "homepage/viewed",
  HOMEPAGE_AI_SEARCH_SUBMITTED: "homepage/ai-search-submitted",
  HOMEPAGE_PRODUCT_CARD_CLICKED: "homepage/product-card-clicked",
  HOMEPAGE_ADVERTISING_CARD_CLICKED: "homepage/advertising-card-clicked",

  // Top nav
  NAV_TEAM_SWITCHER_OPENED: "nav/team-switcher-opened",
  NAV_TEAM_SWITCHED: "nav/team-switched",
  NAV_SEARCH_OPENED: "nav/search-opened",
  NAV_SEARCH_SUBMITTED: "nav/search-submitted",
  NAV_ASK_REDO_CLICKED: "nav/ask-redo-clicked",
  NAV_USER_MENU_OPENED: "nav/user-menu-opened",
  NAV_LOGOUT_CLICKED: "nav/logout-clicked",

  // Left sidebar
  NAV_SIDEBAR_ITEM_CLICKED: "nav/sidebar-item-clicked",
  NAV_SETTINGS_ITEM_CLICKED: "nav/settings-item-clicked",
  NAV_TAB_REORDERED: "nav/tab-reordered",

  // Onboarding & upsell
  MANAGED_RETURNS_TRIAL_SHOWN: "onboarding/managed-returns-trial-shown",
  MANAGED_RETURNS_TRIAL_DISMISSED: "onboarding/managed-returns-trial-dismissed",
  MANAGED_RETURNS_TRIAL_STEP_ADVANCED:
    "onboarding/managed-returns-trial-step-advanced",
  MANAGED_RETURNS_TRIAL_SUBMITTED: "onboarding/managed-returns-trial-submitted",
  UPSELL_CARD_CTA_CLICKED: "upsell/card-cta-clicked",
  UPSELL_PAGE_VIEWED: "upsell/page-viewed",
  UPSELL_CTA_CLICKED: "upsell/cta-clicked",

  // Billing banners
  ...BillingBannerEvents,
  BILLING_ACCEPT_BILLING_CLICKED: "billing/accept-billing-clicked",
  BILLING_CAP_RAISE_CLICKED: "billing/cap-raise-clicked",
  BILLING_ACCEPT_BILLING_VIEWED: "billing/accept-billing-viewed",
  BILLING_CAP_RAISE_VIEWED: "billing/cap-raise-viewed",

  // Permissions banners
  PERMISSIONS_UPDATE_PERMISSIONS_CLICKED:
    "permissions/update-permissions-clicked",
  PERMISSIONS_UPDATE_PERMISSIONS_VIEWED:
    "permissions/update-permissions-viewed",
  PERMISSIONS_RECONNECT_EMAIL_CLICKED: "permissions/reconnect-email-clicked",
  PERMISSIONS_RECONNECT_EMAIL_VIEWED: "permissions/reconnect-email-viewed",

  // Developer banners
  DEVELOPER_FIX_WEBHOOKS_CLICKED: "developer/fix-webhooks-banner-clicked",
  DEVELOPER_FIX_WEBHOOKS_VIEWED: "developer/fix-webhooks-banner-viewed",

  // Redo Supplies
  SUPPLIES_SHOP_VIEWED: "supplies/shop-viewed",
  SUPPLIES_SHOP_SEARCHED: "supplies/shop-searched",
  SUPPLIES_COLLECTION_SELECTED: "supplies/collection-selected",
  SUPPLIES_PRODUCT_OPENED: "supplies/product-opened",
  SUPPLIES_PRODUCT_VIEWED: "supplies/product-viewed",
  SUPPLIES_VARIANT_SELECTED: "supplies/variant-selected",
  SUPPLIES_ITEM_ADDED_TO_CART: "supplies/item-added-to-cart",
  SUPPLIES_FREE_ITEM_CLAIMED: "supplies/free-item-claimed",
  SUPPLIES_RECURRING_SETUP_SUBMITTED: "supplies/recurring-setup-submitted",
  SUPPLIES_CART_OPENED: "supplies/cart-opened",
  SUPPLIES_CHECKOUT_STARTED: "supplies/checkout-started",
  SUPPLIES_CHECKOUT_VIEWED: "supplies/checkout-viewed",
  SUPPLIES_SHIPPING_ADDRESS_SAVED: "supplies/shipping-address-saved",
  SUPPLIES_PAYMENT_METHOD_SELECTED: "supplies/payment-method-selected",
  SUPPLIES_ORDER_PLACED: "supplies/order-placed",

  // Walmart banners
  WALMART_REAUTHORIZE_CLICKED: "walmart/reauthorize-banner-clicked",
  WALMART_REAUTHORIZE_VIEWED: "walmart/reauthorize-banner-viewed",

  // Team deletion banner
  TEAM_DELETION_VIEWED: "team/deletion-banner-viewed",
  TEAM_DELETION_CONTACT_SUPPORT_CLICKED:
    "team/deletion-contact-support-clicked",

  // Merchant banners
  LOG_IN_TO_REDO_VIEWED: "merchant/log-in-to-redo-banner-viewed",

  // Personalized inserts banner
  PERSONALIZED_INSERTS_TERMS_VIEWED:
    "merchant/personalized-inserts-terms-banner-viewed",
  PERSONALIZED_INSERTS_TERMS_REVIEW_CLICKED:
    "merchant/personalized-inserts-terms-review-clicked",

  // Conversion ad landings (intent-only + ppu-intent)
  INTENT_MARKER_WRITTEN: "intent/marker-written",
  PPU_INTENT_MARKER_WRITTEN: "ppu-intent/marker-written",

  // PPU-intent TOFU funnel (marker-scoped, in-app steps after Shopify install)
  PPU_INTENT_TERMS_ACCEPTED: "ppu-intent/terms-accepted",
  PPU_INTENT_SETUP_VIEWED: "ppu-intent/setup-viewed",
} as const;
